// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3A500","select":"Header_select__27iE-","clinic":"Header_clinic__1tKqa"};